import React from 'react';
import { Hero } from './components/Hero';
import { TestimoniosQuick } from './components/TestimoniosQuick';
import { PainBlock } from './components/PainBlock';
import { TomosGrid } from './components/TomosGrid';
import { BonosSection } from './components/BonosSection';
import { Timer } from './components/Timer';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfNotHaving } from './components/CostOfNotHaving';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-brand-green selection:text-white text-center" data-id="element-0">
      <Hero data-id="element-1" />
      <TestimoniosQuick data-id="element-2" />
      <PainBlock data-id="element-3" />
      <TomosGrid data-id="element-4" />
      <BonosSection data-id="element-5" />
      <div className="bg-black py-12 border-y border-white/5 pt-[4px] pb-[4px]" data-id="element-6">
        <Timer data-id="element-7" />
      </div>
      <PricingCards data-id="element-8" />
      <ComparisonTable data-id="element-9" />
      <Testimonials data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <CostOfNotHaving data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}